import React from 'react';

function Picture({ label, pictures, url }) {
  const pictureFile = url || pictures?.find(({ Name }) => Name === label)?.file;

  // if (!pictureFile)
  //   console.log('>>>not found', label);

  if (!pictureFile) {
    return (
      <div className="w-[150px] h-[150px] bg-gray-100 rounded-md flex items-center justify-center">
        <svg className="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    )
  }

  return <img src={pictureFile} alt={label || "Picture"} className="max-w-[150px] max-h-[150px] object-contain" />;
}

export default Picture;